<template>
  <div id="app">
    <ping-timer></ping-timer>
    <router-view></router-view>
  </div>
</template>

<script>
import HelloWorld from './components/ParseContent.vue'
import Login from './components/Login.vue'
import PingTimer from './components/PingTimer.vue'

export default {
  name: 'App',
  components: {
    Login,
    HelloWorld,
    PingTimer
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 1%;
  background: #b9b7b7;
}
</style>
